<!--Show unassigned keys toggle Off-->
<div *ngIf="!showUnassignedKeys">
  <div
    *ngIf="hierarchyItem && (!hierarchyItem.isChangeKey || showChangeKeys) && !hierarchyItem.isFutureKey"
    class="menu-container only-tree no-min"
    (mouseenter)="mouseEnter()"
    (mouseleave)="mouseLeave()"
  >
    <!-- Key Set Symbol -->
    <div class="keyset-symbol-wrapper">
      <div class="keyset-symbol">
        <div
          *ngFor="let level of hierarchyItem?.lineTracker | keyvalue; let first = first; let last = last"
          class="lines"
        >
          <div *ngIf="level.value.key === hierarchyItem.keySetSymbol" class="top"></div>
          <div class="bottom" [ngClass]="{ 'no-border': level.value.value }"></div>
        </div>

        <lib-key
          [disabled]="disabled(hierarchyItem)"
          [canMinimize]="true"
          (click)="selectMasterKey(hierarchyItem)"
          [selectedMasterKey]="selectedMasterKey"
          [hierarchyItem]="hierarchyItem"
          [showChangeKeys]="showChangeKeys"
        >
          <div
            *ngIf="hierarchyItem?.isAssigned || hierarchyItem?.isCrossKeyOperator || hierarchyItem?.isReadyForValidation"
            class="status-icons"
            [ngClass]="{ 'no-min': !hasMinimize(hierarchyItem) }"
          >
            <mat-icon
              matTooltipShowDelay="400"
              matTooltip="Key is Assigned"
              style="color: #2d9d78;"
              *ngIf="hierarchyItem.isAssigned"
            >check</mat-icon>
            <mat-icon
              matTooltipShowDelay="400"
              matTooltip="Key is a Cross Key Operator"
              class="padding xsm left"
              *ngIf="hierarchyItem.isCrossKeyOperator"
            >key</mat-icon>
          </div>
        </lib-key>
      </div>
    </div>

    <lib-key-actions
      *ngIf="hierarchyItem?.parent?.masterKeyTypeId !== keyNodeType.CrossKeyChild"
      [isDisplay]="isDisplay"
      [hierarchyItem]="hierarchyItem"
      [keySystem]="keySystem"
      [isResidentialSystem]="isResidentialSystem"
      [selectedMasterKey]="selectedMasterKey"
      (deleteItemAction)="deleteItem($event)"
      (deleteChildrenAction)="deleteChildren($event)"
      (patchItemAction)="patchItem($event)"
      (addChildAction)="addChild($event)"
    >
    </lib-key-actions>
  </div>
  <ng-container
    *ngIf="hierarchyItem && !hierarchyItem.isChangeKey && hierarchyItem.children && hierarchyItem.children.length > 0 && !hierarchyItem.isFutureKey"
  >
    <div *ngFor="let child of hierarchyItem.sortedChildren; let last = last">
      <lib-master-key-tree
        *ngIf="
          !hierarchyItem?.isMinimized &&
          !(child.isChangeKey && isResidentialSystem && crossKeyHierarchy) &&
          child?.masterKeyTypeId !== 10 &&
          child?.masterKeyTypeId !== 8 &&
          child?.masterKeyTypeId !== 6 &&
          child?.masterKeyTypeId !== 0 &&
          child?.masterKeyTypeId !== 17
        "
        [showChangeKeys]="showChangeKeys"
        [hierarchyItem]="child"
        [keySystem]="keySystem"
        [lastChild]="last"
        [crossKeyHierarchy]="crossKeyHierarchy"
        [ownOperatingKey]="ownOperatingKey"
        [isResidentialSystem]="isResidentialSystem"
        (selectKey)="selectMasterKey($event)"
        (deleteItemAction)="deleteItem($event)"
        (deleteChildrenAction)="deleteChildren($event)"
        (patchItemAction)="patchItem($event)"
        (addChildAction)="addChild($event)"
      >
      </lib-master-key-tree>
    </div>
  </ng-container>
</div>


<!--Show unassigned keys toggle On-->
<div *ngIf="showUnassignedKeys">
  <div
  *ngIf="hierarchyItem && (!hierarchyItem.isChangeKey || showChangeKeys) && !hierarchyItem.isFutureKey"
  class="menu-container only-tree no-min"
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
>
  <!-- Key Set Symbol -->
  <div class="keyset-symbol-wrapper">
    <div class="keyset-symbol">
      <div
        *ngFor="let level of hierarchyItem?.lineTracker | keyvalue; let first = first; let last = last"
        class="lines"
      >
        <div *ngIf="level.value.key === hierarchyItem.keySetSymbol" class="top"></div>
        <div class="bottom" [ngClass]="{ 'no-border': level.value.value }"></div>
      </div>

      <lib-key
        *ngIf="hierarchyItem.showOnUnassignedToggle"
        [disabled]="disabled(hierarchyItem)"
        [canMinimize]="true"
        (click)="selectMasterKey(hierarchyItem)"
        [selectedMasterKey]="selectedMasterKey"
        [hierarchyItem]="hierarchyItem"
        [showChangeKeys]="showChangeKeys"
      >
        <div
        *ngIf="hierarchyItem?.isAssigned || hierarchyItem?.isCrossKeyOperator || hierarchyItem?.isReadyForValidation"
          class="status-icons"
          [ngClass]="{ 'no-min': !hasMinimize(hierarchyItem) }"
        >
          <mat-icon
            matTooltipShowDelay="400"
            matTooltip="Key is Assigned"
            style="color: #2d9d78;"
            *ngIf="hierarchyItem.isAssigned"
          >check</mat-icon>
          <mat-icon
            matTooltipShowDelay="400"
            matTooltip="Key is a Cross Key Operator"
            class="padding xsm left"
            *ngIf="hierarchyItem.isCrossKeyOperator"
          >key</mat-icon>
        </div>
      </lib-key>
    </div>
  </div>

  <lib-key-actions
    *ngIf="hierarchyItem?.parent?.masterKeyTypeId !== keyNodeType.CrossKeyChild"
    [isDisplay]="isDisplay"
    [hierarchyItem]="hierarchyItem"
    [keySystem]="keySystem"
    [isResidentialSystem]="isResidentialSystem"
    [selectedMasterKey]="selectedMasterKey"
    (deleteItemAction)="deleteItem($event)"
    (deleteChildrenAction)="deleteChildren($event)"
    (patchItemAction)="patchItem($event)"
    (addChildAction)="addChild($event)"
  >
  </lib-key-actions>
  </div>
  <ng-container
    *ngIf="hierarchyItem && !hierarchyItem.isChangeKey && hierarchyItem.children && hierarchyItem.children.length > 0 && !hierarchyItem.isFutureKey"
  >
    <div *ngFor="let child of hierarchyItem.sortedChildren; let last = last">
      <lib-master-key-tree
        *ngIf="
          !hierarchyItem.isMinimized &&
          !(child.isChangeKey && isResidentialSystem && crossKeyHierarchy) &&
          child.masterKeyTypeId !== 10 &&
          child.masterKeyTypeId !== 8 &&
          child.masterKeyTypeId !== 6 &&
          child.masterKeyTypeId !== 0 &&
          child.masterKeyTypeId !== 17 &&
          child.showOnUnassignedToggle"
        [showChangeKeys]="showChangeKeys"
        [showUnassignedKeys]="showUnassignedKeys"
        [hierarchyItem]="child"
        [keySystem]="keySystem"
        [lastChild]="last"
        [crossKeyHierarchy]="crossKeyHierarchy"
        [ownOperatingKey]="ownOperatingKey"
        [isResidentialSystem]="isResidentialSystem"
        (selectKey)="selectMasterKey($event)"
        (deleteItemAction)="deleteItem($event)"
        (deleteChildrenAction)="deleteChildren($event)"
        (patchItemAction)="patchItem($event)"
        (addChildAction)="addChild($event)"
      >
      </lib-master-key-tree>
    </div>
    <div *ngIf="showNoKeysMessage" class="margin padding s4 all">
      <span>No unassigned keys exist.</span>
    </div>
  </ng-container>
</div>


<mat-menu #operatorActions *ngIf="hierarchyItem">
  <button mat-menu-item (click)="toggleMasterOperator()">
    <span> {{ hierarchyItem.isMasterOperator ? 'Remove' : 'Apply' }} Master Operator </span>
  </button>
  <button mat-menu-item [disabled]="hierarchyItem.isMasterOperator" (click)="toggleDirectChangesOperate()">
    <span> {{ hierarchyItem.directChangesOperate ? 'Remove' : 'Apply' }} Direct Changes Operate </span>
  </button>
</mat-menu>
